seedWebApp.controller('TrackingCtrl', ['$scope', 'DatabaseService', 'ToastService',
    function ($scope, DatabaseService, ToastService) {
        console.log('DatabaseScripts');


        $scope.getColumns = function (row) {
            if (!row) {
                return null;
            }
            var cols = Object.keys(row);

            //console.log('getColumns');

            return cols;
        };

        $scope.selectTable = function (table) {
            $scope.selTable = table;
        };

        $scope.toggleTable = function (table) {
            //console.log('toggleGroup');
            //console.log(group1);
            table.IsCollapsed = !table.IsCollapsed;            
        };

        $scope.trackOrder = function () {
            console.log('trackOrder: ' + $scope.filterString);

            DatabaseService.trackOrder($scope.filterString).then(
                function (response) {
                    console.log('TrackOK');
                    console.log(response);
                    $scope.tracking = response.data;
                    $scope.tables = response.data.Tables;
                    $scope.selTable = $scope.tables[0];
                },
                function (error) {
                    console.log('Erro tracking');
                    console.log(error);
                    var errMsg = '';
                    if (error.data && error.data.ExceptionMessage) {
                        errMsg = error.data.ExceptionMessage;
                    }
                    $scope.tracking = errMsg;
                }
            );


        };

    }
]
);
